import moment from 'moment'
import services from '@/services/ascentiaServiceIndex'
import { CONNECTIVITY_CONSTS as CC } from '../consts'

const state = {
  fullData: [],
  connectivityData: [],
  connectivityIssues: [],
}

const getters = {
  totalTransfer: state =>
    state.connectivityData.reduce((acc, cur) => acc + cur.totalfilesize, 0),
  totalCount: state =>
    state.connectivityData.reduce((acc, cur) => acc + cur.numFiles, 0),
}

const mutations = {
  [CC.UPDATE_CONN_DATA]: (state, data) => (state.connectivityData = data),
  [CC.UPDATE_FULL_DATA]: (state, data) => (state.fullData = data),
  [CC.UPDATE_CONN_ISSUES]: (state, data) => (state.connectivityIssues = data),
}

const actions = {
  async [CC.GET_FULL_CONNECTIVITY_ISSUES]({ commit }, airlineDetails) {
    try {
      const response = await services.connectivity.getData(
        'fleetFullConnectivity',
        airlineDetails,
        true,
      )
      const cleanData = response.data.map(tail => {
        const lastUpdated = moment(tail.dateLastDataFileReceived)
        let timeSinceDays = moment().diff(lastUpdated, 'days')
        timeSinceDays = parseInt(timeSinceDays)

        return {
          airlineId: tail.airlineId,
          daysSince: timeSinceDays,
          airline: tail.airline,
        }
      })

      commit(CC.UPDATE_CONN_ISSUES, cleanData)
    } catch (error) {
      console.log(CC.GET_FULL_CONNECTIVITY_ISSUES + ': error ' + error)
    }
  },
  async [CC.GET_CONNECTIVITY_FULL_SUMMARY]({ commit }, airlineDetails) {
    try {
      const response = await services.connectivity.getData(
        'fullConnectivityData',
        airlineDetails,
        true,
      )
      const cleanData = response.data.map(tail => {
        const lastUpdated = moment(
          tail.lastUpdated + '+00:00',
          'YYYY-MM-DDTHH:mm:ss.SSSZZ',
        )
        const timeSince = moment().diff(lastUpdated, 'minutes')
        let timeSinceHours = timeSince / (60.0 * 24)
        let level = 'high'
        if (timeSinceHours < 2) {
          level = 'low'
        } else if (timeSinceHours < 7) {
          level = 'medium'
        }

        if (timeSinceHours > 3) {
          timeSinceHours = parseInt(timeSinceHours)
        }
        return {
          platform: tail.platform,
          acid: tail.tail,
          timesince: timeSinceHours,
          level: level,
          numFiles: tail.count,
          avgfilesize: tail.avgSize,
          totalfilesize: tail.totalSize,
        }
      })

      commit(CC.UPDATE_FULL_DATA, cleanData)
    } catch (error) {
      console.log(CC.GET_CONNECTIVITY_FULL_SUMMARY + ': error ' + error)
    }
  },
  async [CC.GET_CONNECTIVITY_SUMMARY]({ commit }, airlineDetails) {
    try {
      const response = await services.connectivity.getData(
        'connectivityData',
        airlineDetails,
        true,
      )
      const cleanData = response.data.map(tail => {
        const lastUpdated = moment(
          tail.lastUpdated + '+00:00',
          'YYYY-MM-DDTHH:mm:ss.SSSZZ',
        )
        const timeSince = moment().diff(lastUpdated, 'minutes')
        let timeSinceHours = timeSince / (60.0 * 24)
        let level = 'high'
        if (timeSinceHours < 2) {
          level = 'low'
        } else if (timeSinceHours < 7) {
          level = 'medium'
        }

        if (timeSinceHours > 3) {
          timeSinceHours = parseInt(timeSinceHours)
        }
        return {
          platform: tail.platform,
          acid: tail.tail,
          timesince: timeSinceHours,
          level: level,
          numFiles: tail.count,
          avgfilesize: tail.avgSize,
          totalfilesize: tail.totalSize,
          flightNumber: tail.flightNumber,
          flightStart: tail.flightStart,
        }
      })

      commit(CC.UPDATE_CONN_DATA, cleanData)
    } catch (error) {
      console.log(CC.GET_CONNECTIVITY_SUMMARY + ': error ' + error)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
